import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "panel panel-section requester-panel p-bottom-4"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "panel-heading has-background-light has-text-weight-semibold is-size-4" }, " Requester ", -1)
const _hoisted_3 = {
  key: 0,
  class: "panel-content"
}
const _hoisted_4 = { class: "is-flex is-align-items-flex-start" }
const _hoisted_5 = { class: "requester-info-icon" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 1,
  class: "m-left-8 pendo-ignore"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "panel-item is-flex is-align-items-flex-start"
}
const _hoisted_11 = { class: "requester-info-icon" }
const _hoisted_12 = { class: "pendo-ignore m-left-8" }
const _hoisted_13 = {
  key: 1,
  class: "panel-item is-flex is-align-items-flex-start"
}
const _hoisted_14 = { class: "requester-info-icon" }
const _hoisted_15 = { class: "m-left-8 pendo-ignore" }
const _hoisted_16 = {
  key: 2,
  class: "panel-item is-flex is-align-items-flex-start"
}
const _hoisted_17 = { class: "requester-info-icon" }
const _hoisted_18 = { class: "m-left-8 pendo-ignore" }
const _hoisted_19 = {
  key: 3,
  class: "panel-item is-flex is-align-items-flex-start"
}
const _hoisted_20 = { class: "requester-info-icon" }
const _hoisted_21 = { class: "m-left-8" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "email-statuses-tip" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "m-bottom-8" }, " Sent: Email was successfully sent from NextRequest. "),
  /*#__PURE__*/_createElementVNode("p", { class: "m-bottom-8" }, " Delivered: The destination email server accepted the message. (This does not guarantee successful delivery to the inbox.) "),
  /*#__PURE__*/_createElementVNode("p", { class: "m-bottom-8" }, " Opened: The email was opened by the requester. ")
], -1)
const _hoisted_23 = {
  key: 0,
  class: "requester-email-statuses"
}
const _hoisted_24 = { class: "requester-email-statuses-events m-left-8 m-top-8" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "help" }, [
  /*#__PURE__*/_createTextVNode(" Can't find the requester? "),
  /*#__PURE__*/_createElementVNode("a", { href: "/admin/users/new" }, "Create a new requester account"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrIcon = _resolveComponent("NrIcon")!
  const _component_NrIconButton = _resolveComponent("NrIconButton")!
  const _component_NrTooltip = _resolveComponent("NrTooltip")!
  const _component_NrButton = _resolveComponent("NrButton")!
  const _component_NrLoadingAnimation = _resolveComponent("NrLoadingAnimation")!
  const _component_NrSelect = _resolveComponent("NrSelect")!
  const _component_NrModal = _resolveComponent("NrModal")!

  return (_ctx.canSeeRequesterPanel)
    ? (_openBlock(), _createElementBlock("article", _hoisted_1, [
        _hoisted_2,
        (!_ctx.filteredRequestLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_ctx.name)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["panel-item is-flex is-align-items-center is-justify-content-space-between", { 'panel-item--editable': _ctx.$can('manage', 'Request') }])
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_NrIcon, { name: "user" })
                      ]),
                      (_ctx.$can('read', 'admin_only_items'))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                            _createElementVNode("a", {
                              href: _ctx.url,
                              class: "has-text-weight-semibold underline m-left-8 pendo-ignore"
                            }, _toDisplayString(_ctx.name), 9, _hoisted_7)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.name), 1))
                    ]),
                    (_ctx.$can('manage', 'Request'))
                      ? (_openBlock(), _createBlock(_component_NrTooltip, {
                          key: 0,
                          label: "Change requester",
                          class: "panel-item-edit"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_NrIconButton, {
                              "aria-label": "Change requester",
                              variant: "minimal-neutral",
                              icon: { name: 'pencil-alt', type: 'regular' },
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCurrentAction('change-requester')))
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.canSeeRequesterDetails)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_ctx.email)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_NrIcon, { name: "envelope" })
                          ]),
                          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.email), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.address)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_NrIcon, { name: "mapmarker-alt" })
                          ]),
                          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.address), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.phone)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_NrIcon, { name: "phone" })
                          ]),
                          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.phone), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.company)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_NrIcon, { name: "university" })
                          ]),
                          _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.company), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.canSeeEmailStatuses && _ctx.emailAvailable)
                      ? (_openBlock(), _createBlock(_component_NrTooltip, { key: 4 }, {
                          label: _withCtx(() => [
                            _hoisted_22
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_NrButton, {
                              variant: "bordered-neutral",
                              class: "m-bottom-16 m-top-16",
                              onClick: _ctx.toggleEmailStatuses
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.emailStatusesText), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.showEmailStatuses)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                          (_ctx.isLoadingEmailStatuses)
                            ? (_openBlock(), _createBlock(_component_NrLoadingAnimation, {
                                key: 0,
                                count: 3
                              }))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (!_ctx.hasAnyEmailStatuses)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, " No email status records. "))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailStatuses, (status) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "requester-email-statuses m-bottom-24",
                                    key: status.id
                                  }, [
                                    _createElementVNode("p", null, [
                                      _createElementVNode("strong", null, _toDisplayString(status.label), 1)
                                    ]),
                                    _createElementVNode("ul", _hoisted_24, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(status.events, (event) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                          key: event.id,
                                          class: "m-bottom-8"
                                        }, _toDisplayString(event.action) + ": " + _toDisplayString(event.time), 1))
                                      }), 128))
                                    ])
                                  ]))
                                }), 128))
                              ], 64))
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createBlock(_component_NrLoadingAnimation, {
              key: 1,
              count: 3
            })),
        _createVNode(_component_NrModal, {
          class: "requester-panel-modal",
          primaryButtonText: "Change requester",
          title: "Change requester",
          hasSecondaryButton: true,
          show: _ctx.currentAction === 'change-requester',
          onOnCloseClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setCurrentAction(''))),
          onOnSecondaryClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setCurrentAction(''))),
          onOnPrimaryClick: _ctx.handleSave
        }, {
          default: _withCtx(() => [
            _createElementVNode("form", {
              onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent","stop"]))
            }, [
              _createElementVNode("fieldset", null, [
                _createVNode(_component_NrSelect, {
                  placeholder: "Search requesters",
                  options: _ctx.dataOptions.requesters,
                  filterable: false,
                  loading: _ctx.dataFetchState.requesters.fetching,
                  hasMore: !_ctx.dataFetchState.requesters.end,
                  modelValue: _ctx.selectedRequester,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedRequester) = $event)),
                  label: "name_with_email",
                  onOpen: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleDataTyping($event, 'requesters'))),
                  onLoadMore: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleDataScroll('requesters'))),
                  onSearch: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleDataTyping($event, 'requesters')))
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(" Search requesters ")
                  ]),
                  _: 1
                }, 8, ["options", "loading", "hasMore", "modelValue"]),
                _hoisted_25
              ])
            ], 32)
          ]),
          _: 1
        }, 8, ["show", "onOnPrimaryClick"])
      ]))
    : _createCommentVNode("", true)
}